import { supabase } from '@/integrations/supabase/client';
import { trackingQueue } from './behaviorTrackingQueue';

// Track user behavior and check for achievements (now batched)
export async function trackBehaviorAndAchievements(
  actionType: string,
  appName?: string,
  metadata?: any
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    // Add to queue instead of immediate call
    trackingQueue.addEvent(actionType, appName, metadata);

    // Check achievements after tracking (fire and forget)
    checkAchievements(user.id).catch(console.error);
  } catch (error) {
    console.error('Error tracking behavior:', error);
  }
}

async function checkAchievements(userId: string) {
  const { checkAllAchievements } = await import('./achievementLogic');
  await checkAllAchievements(userId);
}

// Reset session ID on new session
export function resetSessionId() {
  trackingQueue.resetSession();
}

// Expose queue for manual flushing or debugging
export function flushBehaviorQueue() {
  return trackingQueue.flush();
}

export function getBehaviorQueueStats() {
  return trackingQueue.getQueueStats();
}
